import React from 'react';
import { Button, alpha } from '@mui/material';

import { GatewaySelectorType } from '../../../../types/sidebar.types';
import GatewayItem from './gateway-item';
import GatewaySelectorMenu from './gateway-selector-menu';
import { useGateway } from 'hooks';

export const GatewaySelector = ({ collapse }: GatewaySelectorType) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const active = useGateway();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                fullWidth
                variant="outlined"
                disableElevation
                onClick={handleClick}
                aria-expanded={open}
                sx={(theme) => ({
                    minWidth: 0,
                    minHeight: theme.spacing(7.25),

                    px: `${theme.spacing(1.25)} !important`,
                    py: `${theme.spacing(1)} !important`,

                    justifyContent: 'space-between',

                    borderRadius: 1,
                    borderWidth: 1,
                    borderStyle: 'solid',

                    borderColor: open
                        ? theme.palette.primary.main
                        : theme.palette.border.main,

                    backgroundColor: open
                        ? alpha(theme.palette.primary.main, 0.055)
                        : alpha(theme.palette.background.extraLight ?? theme.palette.background.paper, 0.86),

                    backgroundImage: 'none',

                    color: theme.palette.text.primary,

                    boxShadow: open
                        ? `0 0 0 3px ${alpha(
                              theme.palette.primary.main,
                              theme.palette.mode === 'dark' ? 0.3 : 0.14,
                          )}`
                        : 'none',

                    transition: theme.transitions.create(
                        [
                            'background-color',
                            'border-color',
                            'box-shadow',
                        ],
                        {
                            duration: theme.transitions.duration.shortest,
                        },
                    ),

                    '&:hover': {
                        borderColor: open
                            ? theme.palette.primary.main
                            : theme.palette.border.strong ??
                              theme.palette.border.main,

                        backgroundColor:
                            alpha(theme.palette.primary.main, 0.045),

                        boxShadow: open
                            ? `0 0 0 3px ${alpha(
                                  theme.palette.primary.main,
                                  theme.palette.mode === 'dark'
                                      ? 0.3
                                      : 0.14,
                              )}`
                            : 'none',
                    },

                    '&:focus-visible': {
                        borderColor: theme.palette.primary.main,
                        boxShadow: `0 0 0 3px ${alpha(
                            theme.palette.primary.main,
                            theme.palette.mode === 'dark' ? 0.35 : 0.16,
                        )}`,
                    },

                    i: {
                        color: open
                            ? theme.palette.primary.light
                            : theme.palette.text.light,

                        transition: theme.transitions.create(
                            ['color', 'transform'],
                            {
                                duration:
                                    theme.transitions.duration.shortest,
                            },
                        ),

                        transform: open
                            ? 'rotate(-90deg)'
                            : 'rotate(0deg)',
                    },

                    ...(collapse && {
                        minHeight: theme.spacing(6),
                    }),
                })}
            >
                {active ? (
                    <GatewayItem
                        collapse={collapse}
                        title={active.title}
                        website={active.website}
                    />
                ) : (
                    <GatewayItem
                        collapse={collapse}
                        title="انتخاب درگاه"
                        website="درگاه موردنظر را انتخاب کنید"
                    />
                )}

                {collapse && (
                    <i className="fa-light fa-chevron-left" />
                )}
            </Button>

            <GatewaySelectorMenu
                anchorEl={anchorEl}
                handleClose={handleClose}
                open={open}
            />
        </>
    );
};